export function setSelectedDate(data){
    return{
        type: "SET_KOTCHARAM_DATE",
        data: data
    }
}